module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(_vm.$route.name === 'upActivity' && (_vm.activity.status === 0 || _vm.activity.status === 1)) ? _c('div', {
    staticClass: "text-right"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('li', {
    class: {
      'active': _vm.cMethod == 1
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.checkActivity(true, 1)
      }
    }
  }, [_c('a', [_vm._v("活動資訊")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.cMethod == 2
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.checkActivity(true, 2)
      }
    }
  }, [_c('a', [_vm._v("贈送規則")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.cMethod == 3
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.checkActivity(true, 3)
      }
    }
  }, [_c('a', [_vm._v("折抵規則")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.cMethod == 4
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.checkActivity(true, 4)
      }
    }
  }, [_c('a', [_vm._v("優惠券")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cMethod === 1),
      expression: "cMethod === 1"
    }],
    staticClass: "row m-b-15 center-block"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.title),
      expression: "activity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.name),
      expression: "activity.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.sort),
      expression: "activity.sort"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "2"
    },
    domProps: {
      "value": (_vm.activity.sort)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity, "sort", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.content),
      expression: "activity.content"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "活動說明",
      "maxlength": "256"
    },
    domProps: {
      "value": (_vm.activity.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity, "content", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("活動說明(後台)")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.description),
      expression: "activity.description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "活動說明",
      "maxlength": "256"
    },
    domProps: {
      "value": (_vm.activity.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-right"
  }, [(_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.ownerTypeOptions,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "擁有者",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.activity.owner_type),
      callback: function($$v) {
        _vm.$set(_vm.activity, "owner_type", $$v)
      },
      expression: "activity.owner_type"
    }
  })], 1)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getRoleType === 99 || (_vm.getRoleType === 30 && !_vm.info.info.activity_id)),
      expression: "getRoleType === 99 || (getRoleType === 30 && !info.info.activity_id)"
    }]
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), (_vm.activity.owner_type.value === 1) ? _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.brandBrief,
      "label": "label",
      "track-by": "label",
      "searchable": false,
      "allow-empty": true,
      "close-on-select": false,
      "clear-on-select": false,
      "placeholder": "品牌",
      "show-labels": false,
      "multiple": true
    },
    on: {
      "input": _vm.getMutiStore
    },
    model: {
      value: (_vm.brandSelectMuti),
      callback: function($$v) {
        _vm.brandSelectMuti = $$v
      },
      expression: "brandSelectMuti"
    }
  })], 1) : _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.brandBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "品牌",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "label"
    },
    on: {
      "input": _vm.getStore
    },
    model: {
      value: (_vm.brandSelect),
      callback: function($$v) {
        _vm.brandSelect = $$v
      },
      expression: "brandSelect"
    }
  })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group cr-schedule"
  }, [_vm._m(7), _vm._v(" "), _c('date-time-picker', {
    attrs: {
      "date": _vm.activity.aTime.start,
      "option": _vm.timeoption,
      "limit": _vm.startLimit
    }
  })], 1), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group cr-schedule"
  }, [_vm._m(8), _vm._v(" "), _c('date-time-picker', {
    attrs: {
      "date": _vm.activity.aTime.end,
      "option": _vm.timeoption,
      "limit": _vm.endLimit
    }
  })], 1), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("活動備註")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.remark),
      expression: "activity.remark"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "活動說明"
    },
    domProps: {
      "value": (_vm.activity.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity, "remark", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')])]), _vm._v(" "), (_vm.getRoleType !== 10) ? _c('div', {
    staticClass: "col-xs-12 p-sm-10-p m-x-10 form-left"
  }, [_vm._m(9), _vm._v(" "), _c('muti-select-two', {
    attrs: {
      "setting": _vm.addStoresSetting,
      "reNew": _vm.reNew,
      "reSet": _vm.reSet
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cMethod === 2),
      expression: "cMethod === 2"
    }],
    staticClass: "row m-b-15 center-block"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('activity-strategy', {
    attrs: {
      "activity": _vm.activity,
      "info": _vm.info,
      "brandList": _vm.brandList,
      "addStoresSetting": _vm.addStoresSetting,
      "storeList": _vm.aStoreList,
      "aStoreOption": _vm.aStoreOption,
      "setInfoTimes": _vm.setInfoTimes
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cMethod === 3),
      expression: "cMethod === 3"
    }],
    staticClass: "row m-b-15 center-block"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('coupon-strategy', {
    attrs: {
      "giveCoupons": _vm.giveCoupons,
      "info": _vm.info,
      "brandList": _vm.brandList,
      "addStoresSetting": _vm.addStoresSetting,
      "storeList": _vm.aStoreList,
      "aStoreOption": _vm.aStoreOption,
      "setInfoTimes": _vm.setInfoTimes
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cMethod === 4),
      expression: "cMethod === 4"
    }],
    staticClass: "row m-b-15 center-block"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('coupon-list', {
    attrs: {
      "giveCoupons": _vm.giveCoupons,
      "info": _vm.info,
      "brandList": _vm.brandList,
      "storeList": _vm.aStoreList,
      "activity": _vm.activity,
      "setInfoTimes": _vm.setInfoTimes
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_vm._v("ˋ\n      "), (_vm.cMethod === 1) ? _c('button', {
    staticClass: "btn btn-fail",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n        取消\n      ")]) : _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        _vm.cMethod--
      }
    }
  }, [_vm._v("\n        上一步\n      ")]), _vm._v(" "), (_vm.cMethod === 4 && _vm.$route.name === 'crActivityInfoForm') ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkActivity(false, 0)
      }
    }
  }, [_vm._v("\n        新增\n      ")]) : (_vm.cMethod === 4 && _vm.$route.name === 'upActivity') ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkActivity(false, 0)
      }
    }
  }, [_vm._v("\n        更新\n      ")]) : _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkActivity(false, 0)
      }
    }
  }, [_vm._v("\n        下一步\n      ")])]), _vm._v(" "), _vm._l((_vm.couponList), function(cInfo, index) {
    return _c('div', [_c('div', {
      staticClass: "modal fade",
      attrs: {
        "id": 'couponRegisterModal' + index,
        "role": "dialog"
      }
    }, [_c('div', {
      staticClass: "modal-dialog choose-modal"
    }, [_c('div', {
      staticClass: "modal-content pull-left"
    }, [_vm._m(10, true), _vm._v(" "), (_vm.coupon.coupon_info) ? _c('div', {
      staticClass: "card m-y-1 pull-left m-y-10 c-pointer",
      staticStyle: {
        "width": "calc(100% - 80px)"
      },
      attrs: {
        "data-target": '#couponRegisterModal' + index,
        "data-toggle": "modal"
      },
      on: {
        "click": function($event) {
          return _vm.clickCoupon()
        }
      }
    }, [_c('div', {
      staticClass: "coupon-left p-10"
    }, [_c('h4', [(_vm.coupon.coupon_info.name) ? _c('span', [_vm._v(_vm._s(_vm.coupon.coupon_info.name))]) : _c('span', [_vm._v("優惠券名稱")])]), _vm._v(" "), _c('h5', [(_vm.coupon.coupon_info.description) ? _c('span', [_vm._v(_vm._s(_vm.coupon.coupon_info.description))]) : _c('span', [_vm._v("優惠券描述....")])]), _vm._v(" "), _c('h5', [_vm._v("到期："), (_vm.coupon.time_config.start_time.time) ? _c('span', [_vm._v(_vm._s(_vm.coupon.time_config.start_time.time) + " ~ " + _vm._s(_vm.coupon.time_config.end_time.time))]) : _c('span', [_vm._v(_vm._s(_vm.nowTime) + " ~ " + _vm._s(_vm.nowTime))])])]), _vm._v(" "), _c('div', {
      staticClass: "coupon-right p-10"
    }, [_c('div', {
      staticClass: "v-middle"
    }, [_vm._v("\n                  $"), (_vm.coupon.coupon_info.discount_value) ? _c('span', [_vm._v(_vm._s(_vm.coupon.coupon_info.discount_value))]) : _c('span', [_vm._v("10")])])])]) : _vm._e()])])])])
  })], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delModal"
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("活動名稱(前台)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("活動名稱(後台)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("活動順序")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("活動說明(前台)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("擁有者\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("參與品牌\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("活動開始時間\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("活動結束時間\n                      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("參與店家")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header pull-left w-100-p"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title text-left"
  }, [_vm._v("優惠券設定")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-061641f0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Marketing/Temp/ActivityForm.vue
// module id = 2302
// module chunks = 1